import React from 'react';
import { t } from 'locale';
import { routes } from 'routes';
import { useHistory } from 'react-router-dom';

import { MarkDown } from 'components/MarkDown';
import { Button } from 'components/_V2/Button/Button';
import { WarningIcon } from 'components/Icons/V2/WarningIcon';

import { localeKeys } from 'enums/localeKeys';

interface RestrictAppProps {
  restrictAppMessage: string;
  isWithLoginLink: boolean;
  isWithTitle: boolean;
}

export const RestrictApp = ({
  restrictAppMessage,
  isWithLoginLink,
  isWithTitle
}: RestrictAppProps) => {
  const history = useHistory();

  return (
    <div className="centered-container mx-auto items-center">
      <div className="h-4" />
      <WarningIcon height={70} width={70} />
      <div className="h-10" />
      <div className="flex flex-col items-center space-y-6  py-6">
        {isWithTitle && <h3 className="text-center">{t(localeKeys.welcomeBankText)}</h3>}
        <MarkDown text={restrictAppMessage} className="text-body-standard-regular text-center" />
      </div>

      <div className="h-4" />
      {isWithLoginLink && (
        <div className="static-page-buttons-container">
          <span data-id="text-already-signed-up" className="text-body-standard-regular">
            {t(localeKeys.alreadySignedUp)}
          </span>
          <Button variant="tertiary" onClick={() => history.push(routes.login.path)}>
            {t(localeKeys.backToLogin)}
          </Button>
        </div>
      )}
    </div>
  );
};
